import { FC } from 'react';


import { useAutorizacao } from 'view/component/Autorizacao/useAutorizacao';
import { SolicitacaoDetalhada } from 'model/solicitacao/SolicitacaoDetalhada';
import { solicitacaoAceitaComentario } from 'business/validacao/ComentarioValidacao';

import { Comentario } from 'model/solicitacao/comentario/Comentario';
import { NovoComentarioTagFormulario } from './NovoComentarioTagFormulario';
import { SituacaoTag } from 'view/component/Situacao/SituacaoTag';
import { MensagensErroServidorView } from 'view/component/MensagensErroServidor/MensagensErroServidorView';


export interface NovoComentarioTagProps {
  solicitacao: SolicitacaoDetalhada;
  /**
   * Chamado quando o comentário foi persistido
   */
  onSalvo: (comentario: Comentario) => void;
}


export const NovoComentarioTag: FC<NovoComentarioTagProps> = ({solicitacao, onSalvo}) => {
  const autorizacao = useAutorizacao();
  const podeComentar = solicitacaoAceitaComentario(solicitacao, autorizacao);
  
  if (!podeComentar) {
    return <MensagensErroServidorView titulo={''} aparencia="information">
      Não é possível adicionar novos comentários em uma solicitação com situação <SituacaoTag situacao={solicitacao.situacao} />
    </MensagensErroServidorView>
    
  }

  return <NovoComentarioTagFormulario solicitacao={solicitacao} onSalvo={onSalvo} />
}